module.exports = __webpack_public_path__ + "static/media/burgerBuilderProject.e62ec685.png";